import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { getClassName, THEMES } from '../../utils'

import './spinner.component.scss'

/**
 * Spinner Component
 */
class Spinner extends PureComponent {
  /**
   * Render Spinner
   * @return {XML}
   */
  render () {
    const { fixed, theme, includeMessage, mask, maskOpacity, maskColor } = this.props

    const baseClassName = getClassName('spinner', [
      { condition: theme, trueClassName: `spinner--${theme}` },
      { condition: fixed, trueClassName: 'spinner--fixed' }
    ])

    const styles = {
      backgroundColor: maskColor || '#000000',
      opacity: maskOpacity || 0.15
    }

    return (
      <div className={baseClassName}>
        {includeMessage && (
          <>
            <i className='spinner_logo q4i-logo' />
            <span className='spinner_message'>One moment... Making magic happen.</span>
          </>
        )}
        <div className='spinner_pulse' />
        {mask && (
          <div className='spinner_mask' style={styles} />
        )}
      </div>
    )
  }
}

Spinner.propTypes = {
  /**
   * Used to determine whether or not the loader renders above all window content using position: fixed
   * By default,
   */
  fixed: PropTypes.bool,

  theme: PropTypes.oneOf([THEMES.RAIN, THEMES.CITRUS, THEMES.WHITES]),
  mask: PropTypes.bool,
  maskOpacity: PropTypes.number,
  maskColor: PropTypes.string,
  includeMessage: PropTypes.bool
}

Spinner.defaultProps = {
  theme: THEMES.RAIN,
  fixed: false,
  mask: false,
  includeMessage: false
}

export default Spinner
